import { put, takeEvery } from 'redux-saga/effects';

import { ReportAction } from '../actions';
import { ReportConstant } from '../constants';

export default function* () {
  yield takeEvery(
    ReportConstant.GET_SALES_REPORT_SUCCESS,
    getSalesReportSuccess,
  );
  yield takeEvery(
    ReportConstant.GET_STOCKS_REPORT_SUCCESS,
    getStocksReportSuccess,
  );
}

function* getSalesReportSuccess(action) {
  yield put(ReportAction.setReport({ data: action?.payload, name: 'sales' }));
}

function* getStocksReportSuccess(action) {
  yield put(ReportAction.setReport({ data: action?.payload, name: 'stocks' }));
}
